<template>
    <b-pagination-nav
        v-if="pagesCount > 1"
        :link-gen="linkGen"
        :number-of-pages="pagesCount"
        :value="currentPage"
        use-router
    />
</template>

<script>
export default {
    name: "Pagination",
    props: {
        baseUrl: {
            type: String,
            required: true,
        },
        search: {
          type: Object,
          required: true,
        },
        totalItems: {
            type: Number,
            required: true,
        },
        methodName: {
            type: String,
            required: true,
        },
    },
    computed: {
        currentPage() {
            let page = this.$route.params.page

            if (page === undefined) {
                return 1
            }

            return page
        },
        pagesCount() {
            if (this.totalItems === 0) {
                return 1
            }

            return Math.ceil(this.totalItems / 10)
        },
    },
    methods: {
        linkGen(pageNum) {
            return this.$i18nHelper.getUrl(this.baseUrl + '/page/' + pageNum)
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.$root.showOverlay = true
                this.search.page = this.currentPage
                this.search.isNeedFetch = true

                this.$store.dispatch(this.methodName, this.search)
                    .then(() => {
                        this.$root.showOverlay = false
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            }
        }
    },
}
</script>

<style scoped>

</style>